import { Typography, TypographyProps } from '@mui/material'

type TProps = {
  value: number
  component?: any
  color?: TypographyProps['color']
  sx?: TypographyProps['sx']
} & Intl.NumberFormatOptions
export default function BigStatCurrency(props: TProps) {
  const { value, color, component, sx, ...formatOpts } = props
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    compactDisplay: 'long',
    maximumFractionDigits: 0,
    ...formatOpts,
  })
  return (
    <Typography
      color={color}
      component={component}
      sx={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'flex-start',
        lineHeight: 0.75,
        ...(sx || {}),
      }}
    >
      {formatter.formatToParts(value).map((part, i) => {
        const isBig = ['integer', 'group'].includes(part.type)
        return (
          <span key={`${part.type}_${i}`} style={{ fontSize: isBig ? undefined : '0.5em' }}>
            {part.value}
          </span>
        )
      })}
    </Typography>
  )
}
